import React from "react";

const NoMatch = () => {
  return (
    <div>
      <div></div>
    </div>
  );
};

export default NoMatch;
